import { Link } from "react-router-dom";
import { Logo } from "./Header";

const cols = [
  {
    title: "Platform",
    links: [
      { to: "/platform", label: "Capabilities" },
      { to: "/channels", label: "Channels" },
      { to: "/audience-data", label: "Audience & Data" },
      { to: "/pricing", label: "Pricing" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/why-responsiq", label: "Why RresponsIQ" },
      { to: "/company", label: "About Xyle" },
      { to: "/book-demo", label: "Book a Demo" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Service" },
      { to: "/opt-out", label: "Opt Out" },
    ],
  },
];

export const Footer = () => (
  <footer className="panel-dark border-t border-[#D8E2E6]" data-testid="site-footer">
    <div className="container-riq py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
      <div className="col-span-2">
        <Logo dark />
        <p className="mt-4 text-sm text-[#F7F9FA]/70 leading-relaxed max-w-xs">
          The omnichannel DSP built for total auction transparency. Media at cost. One disclosed fee. Your data, always yours.
        </p>
        <a
          href="https://xyle.tech"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 inline-flex items-center gap-2.5 group"
          data-testid="footer-xyle-link"
        >
          <span className="font-nav text-[10px] uppercase tracking-widest text-[#F7F9FA]/50 group-hover:text-[#F7F9FA]/80 transition-colors">A product of</span>
          <img src="/assets/xyle-logo.png" alt="Xyle" className="h-5 w-auto opacity-80 group-hover:opacity-100 transition-opacity" />
        </a>
      </div>
      {cols.map((c) => (
        <nav key={c.title} aria-label={c.title}>
          <h3 className="font-nav text-xs uppercase tracking-widest font-bold text-[#32A2C5] mb-4">{c.title}</h3>
          <ul className="space-y-2.5">
            {c.links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="font-nav text-sm text-[#F7F9FA]/80 hover:text-[#32A2C5] transition-colors" data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      ))}
    </div>
    <div className="border-t border-[#F7F9FA]/15">
      <div className="container-riq py-6">
        <p className="font-nav text-[10px] uppercase tracking-widest text-[#F7F9FA]/50">
          © 2026 RresponsIQ — All Rights are Reserved with Xyle.
        </p>
      </div>
    </div>
    <div className="overflow-hidden select-none" aria-hidden="true">
      <p className="font-display font-black uppercase text-[18vw] leading-[0.8] text-[#F7F9FA]/[0.05] text-center whitespace-nowrap -mb-[4vw]">
        RresponsIQ
      </p>
    </div>
  </footer>
);
